import { handleShowModal } from 'components/global/_helpers/global.helpers';
import ContextMenu from 'components/global/ContextMenu';
import { handleClickEditPerson } from 'components/views/InvestorTeam/_helpers/investorTeam.events';
import { $view } from 'signals/global.signals';

const InvestorPersonRows = ({ data }) => data.map((person) => ({
  ...person,
  id: person.id,
  firstName: person.firstName,
  lastName: person.lastName,
  name: `${person.firstName} ${person.lastName}`,
  email: person.email,
  Roles: $view.value.roleOptions
    ?.filter((option) => person.roles?.includes(option.value))
    .map((option) => option.label)
    .join(', '),
  Teams: $view.value.teamOptions
    ?.filter((option) => person.teams?.includes(option.value))
    .map((option) => option.label)
    .join(', '),
  Actions: (
    <ContextMenu
      menuItems={[
        {
          label: 'Edit',
          onClick: () => handleClickEditPerson(person),
        },
        {
          label: 'Delete',
          onClick: () => handleShowModal('delete-person', { id: person.id, firstName: person.firstName, lastName: person.lastName }),
        },
      ]}
    />
  ),
}));

export default InvestorPersonRows;
